import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, Col, Row, Input, Button, Upload, Spin } from 'antd';
import _ from 'lodash';

import ImageUploaderUtil from 'shared/utils/ImageUploaderUtil';
import {
  updloadImageState,
  regexPattern,
  submitModalState,
  audiences,
} from 'shared/constant';

import CallbackModal from 'components/CallbackModal';
import CompanyModules from './CompanyModules';
import CompanyModulesView from './CompanyModulesView';
import EmployeeRolesView from './EmployeeRolesView';
import text from './CompanyRegister.page.translation';
import SubmitModal from '../../components/SubmitModal/SubmitModal.component';

import organizationRoute from '../../route';

import './CompanyRegister.style.less';

class FormCompanyRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValue: {},
      formVendorSubmit: {},
      picPhotoFileList: [],
      isPicPhotoExceed: false,
      isPicPhotoIncorrectFormat: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.companyId &&
      this.props.companyDetails !== prevProps.companyDetails &&
      this.props.companyDetails.payload
    ) {
      const companyData = this.props.companyDetails.payload;
      this.props.form.setFieldsValue({
        companyName: companyData.name,
        companyAddress: companyData.address,
        companyOwner: companyData.owner_fullname,
        companyEmail: companyData.owner_email,
        companyID: companyData.organization_id,
        npwpNumber: companyData.npwp_number,
        legalEntity: companyData.legal_entity,
      });
    }

    if (
      this.props.companyId &&
      this.props.employeeDetails !== prevProps.employeeDetails &&
      this.props.employeeDetails.payload
    ) {
      const employeeData = this.props.employeeDetails.payload;
      const firstname = employeeData.firstname || '';
      const lastname = employeeData.lastname || '';
      const picName = `${firstname} ${lastname}`;

      const defaultFileList = [
        {
          uid: '-1',
          name: employeeData.user_details.profile_picture_url,
          status: 'done',
          url: employeeData.user_details.profile_picture_url,
        },
      ];

      this.props.form.setFieldsValue({
        picName,
        picEmail: employeeData.user_details.email,
        picPhone: employeeData.user_details.phone_mobile,
        picNationalID: employeeData.ktp_num,
        availableEmployeeRoles: employeeData.user_details.user_role,
        picPicture: defaultFileList,
      });

      this.setDefaultPicPicture(defaultFileList);
    }

    if (!_.isEqual(this.props.employeeRoles, prevProps.employeeRoles)) {
      const checkedRoles = this.props.employeeRoles.filter(x => x.checked);
      if (checkedRoles.length > 0) {
        this.props.form.setFieldsValue({
          availableEmployeeRoles: checkedRoles,
        });
      } else {
        this.props.form.setFieldsValue({
          availableEmployeeRoles: [],
        });
      }
    }

    if (!_.isEqual(this.props.availableModules, prevProps.availableModules)) {
      const checkedModules = this.props.availableModules.filter(x => x.checked);
      if (checkedModules.length > 0) {
        this.props.form.setFieldsValue({
          availableModules: checkedModules,
        });
      } else {
        this.props.form.setFieldsValue({
          availableModules: [],
        });
      }
    }
  }

  setDefaultPicPicture = defaultFileList => {
    this.setState({
      picPhotoFileList: defaultFileList,
    });
  };

  onChangeUploadPicPhoto(info) {
    const lastFileList = info.fileList.slice(-1);

    if (lastFileList.length > 0) {
      const lastFile = lastFileList[0];
      const fileExt = ImageUploaderUtil.getFileExtByFileName(lastFile.name);
      const newFileName = ImageUploaderUtil.getNewFileName(fileExt);
      const newFileObj = ImageUploaderUtil.getNewFileObj(
        lastFile.originFileObj,
        newFileName,
        fileExt,
      );

      lastFileList[0].name = newFileName;
      lastFileList[0].originFileObj = newFileObj;
    }

    const fileState = ImageUploaderUtil.getUploadImageState(info.file);

    let newState = null;
    switch (fileState) {
      case updloadImageState.REMOVED:
        newState = {
          ...this.state,
          picPhotoFileList: [],
          isPicPhotoExceed: false,
          isPicPhotoIncorrectFormat: false,
        };
        break;
      case updloadImageState.FILE_SIZE_EXCEED:
        newState = {
          ...this.state,
          isPicPhotoExceed: true,
          isPicPhotoIncorrectFormat: false,
        };
        break;
      case updloadImageState.INVALID_TYPE:
        newState = {
          ...this.state,
          isPicPhotoIncorrectFormat: true,
          isPicPhotoExceed: false,
        };
        break;
      case updloadImageState.VALID:
        newState = {
          ...this.state,
          picPhotoFileList: lastFileList,
          isPicPhotoExceed: false,
          isPicPhotoIncorrectFormat: false,
        };
        break;
      default:
        break;
    }

    if (newState) {
      this.setState(newState);
    }
  }

  uploadValidator(rule, value, callback) {
    if (value.file && value.file.status === updloadImageState.REMOVED) {
      callback(this.props.intl.formatMessage(text.formRequiredCompanyPICPhoto));
    }

    callback();
  }

  onSelectEmployeeRoles = (role, checked) => {
    const newEmployeeRoles = this.props.employeeRoles.map(roles => ({
      ...roles,
    }));
    for (let i = 0; i < newEmployeeRoles.length; i += 1) {
      if (newEmployeeRoles[i].id === role.id) {
        newEmployeeRoles[i].checked = checked;
        break;
      }
    }

    this.props.updateEmployeeRolesAll(newEmployeeRoles);
  };

  onBeforeImageUpload = () => false;

  renderCompany = () => {
    const {
      intl: { formatMessage },
      companyId,
    } = this.props;
    const { formValue } = this.state;
    const { getFieldDecorator } = this.props.form;

    const defaultCompanyName = _.get(formValue, 'companyName', '');
    const defaultCompanyId = _.get(formValue, 'companyID', '');
    const defaultCompanyNpwp = _.get(formValue, 'npwpNumber', '');
    const defaultCompanyLegal = _.get(formValue, 'legalEntity', '');
    const defaultCompanyOwner = _.get(formValue, 'companyOwner', '');
    const defaultCompanyEmail = _.get(formValue, 'companyEmail', '');
    const defaultCompanyAddress = _.get(formValue, 'companyAddress', '');

    return (
      <div className="page-section-box">
        <Row className="page-title-container">
          <Col span={24}>{formatMessage(text.formLeftTitle)}</Col>
        </Row>
        <Row gutter={24} type="flex">
          <Col span={12} className="column-separator">
            <div className="page-column-container">
              <Form.Item
                label={formatMessage(text.formLabelCompanyName)}
                required
                colon={false}
              >
                {getFieldDecorator('companyName', {
                  initialValue: defaultCompanyName,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredCompanyName),
                    },
                  ],
                })(
                  <Input
                    placeholder={formatMessage(text.formPlaceholderCompanyName)}
                    size="large"
                  />,
                )}
              </Form.Item>
              {companyId && (
                <Form.Item
                  label={formatMessage(text.formLabelCompanyID)}
                  colon={false}
                >
                  {getFieldDecorator('companyID', {
                    initialValue: defaultCompanyId,
                    rules: [],
                  })(
                    <Input
                      placeholder={formatMessage(text.formPlaceholderCompanyID)}
                      size="large"
                      disabled
                    />,
                  )}
                </Form.Item>
              )}
              <Form.Item
                label={formatMessage(text.formLabelNpwpNumber)}
                colon={false}
              >
                {getFieldDecorator('npwpNumber', {
                  initialValue: defaultCompanyNpwp,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredNpwpNumber),
                    },
                  ],
                })(
                  <Input
                    placeholder={formatMessage(text.formPlaceholderNpwpNumber)}
                    size="large"
                  />,
                )}
              </Form.Item>
              <Form.Item
                label={formatMessage(text.formLabelLegalEntity)}
                colon={false}
              >
                {getFieldDecorator('legalEntity', {
                  initialValue: defaultCompanyLegal,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredLegalEntity),
                    },
                  ],
                })(
                  <Input
                    placeholder={formatMessage(text.formPlaceholderLegalEntity)}
                    size="large"
                  />,
                )}
              </Form.Item>
            </div>
          </Col>
          <Col span={12}>
            <div className="page-column-container">
              <Form.Item
                label={formatMessage(text.formLabelOwner)}
                required
                colon={false}
              >
                {getFieldDecorator('companyOwner', {
                  initialValue: defaultCompanyOwner,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredOwner),
                    },
                  ],
                })(
                  <Input
                    placeholder={formatMessage(text.formPlaceholderOwner)}
                    size="large"
                  />,
                )}
              </Form.Item>
              <Form.Item
                label={formatMessage(text.formLabelEmail)}
                required
                colon={false}
              >
                {getFieldDecorator('companyEmail', {
                  initialValue: defaultCompanyEmail,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredEmail),
                    },
                  ],
                })(
                  <Input
                    className="email-input"
                    placeholder={formatMessage(
                      text.formPlaceholderCompanyEmail,
                    )}
                    size="large"
                  />,
                )}
              </Form.Item>
              <Form.Item
                label={formatMessage(text.formLabelAddress)}
                required
                colon={false}
              >
                {getFieldDecorator('companyAddress', {
                  initialValue: defaultCompanyAddress,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredAddress),
                    },
                  ],
                })(
                  <Input
                    placeholder={formatMessage(text.formPlaceholderAddress)}
                    size="large"
                  />,
                )}
              </Form.Item>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderCompanyPIC = () => {
    const {
      intl: { formatMessage },
      companyId,
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { formValue } = this.state;

    const picPhotoProps = {
      beforeUpload: this.onBeforeImageUpload,
      onChange: this.onChangeUploadPicPhoto.bind(this),
      fileList: this.state.picPhotoFileList,
    };

    let disableEmail = false;
    if (companyId) {
      disableEmail = true;
    }

    const defaultPicName = _.get(formValue, 'picName', '');
    const defaultPicEmail = _.get(formValue, 'picEmail', '');
    const defaultPicPhone = _.get(formValue, 'picPhone', '');
    const defaultPicNationalID = _.get(formValue, 'picNationalID', '');
    const defaultPicPicture = _.get(formValue, 'picPicture', '');

    return (
      <div className="page-section-box">
        <Row className="page-title-container">
          <Col span={24}>{formatMessage(text.formRightTitle)}</Col>
        </Row>
        <Row gutter={24} type="flex">
          <Col span={12} className="column-separator">
            <div className="page-column-container">
              <Form.Item
                label={formatMessage(text.formLabelCompanyPICName)}
                required
                colon={false}
              >
                {getFieldDecorator('picName', {
                  initialValue: defaultPicName,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredCompanyPICName),
                    },
                  ],
                })(
                  <Input
                    placeholder={formatMessage(
                      text.formPlaceholderCompanyPICName,
                    )}
                    size="large"
                  />,
                )}
              </Form.Item>
              <Form.Item
                label={formatMessage(text.formLabelCompanyPICPhone)}
                required
                colon={false}
              >
                {getFieldDecorator('picPhone', {
                  initialValue: defaultPicPhone,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredPicPhone),
                    },
                    {
                      pattern: regexPattern.PHONE,
                      message: formatMessage(text.companyFormInvalidPhone),
                    },
                  ],
                })(
                  <Input
                    placeholder={formatMessage(
                      text.formPlaceholderCompanyPICPhone,
                    )}
                    size="large"
                  />,
                )}
              </Form.Item>
              <Form.Item
                label={formatMessage(text.formLabelCompanyPICID)}
                required
                colon={false}
              >
                {getFieldDecorator('picNationalID', {
                  initialValue: defaultPicNationalID,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredPicNationalID),
                    },
                    {
                      pattern: regexPattern.NUMBER,
                      message: formatMessage(text.companyFormInvalidNationalID),
                    },
                  ],
                })(
                  <Input
                    placeholder={formatMessage(
                      text.formPlaceholderCompanyPICID,
                    )}
                    size="large"
                  />,
                )}
              </Form.Item>
            </div>
          </Col>
          <Col span={12}>
            <div className="page-column-container">
              <Form.Item
                label={formatMessage(text.formLabelCompanyPICEmail)}
                required
                colon={false}
              >
                {getFieldDecorator('picEmail', {
                  initialValue: defaultPicEmail,
                  rules: [
                    {
                      type: 'email',
                      message: formatMessage(text.formInvalidEmail),
                    },
                    {
                      required: true,
                      message: formatMessage(text.formRequiredEmail),
                    },
                  ],
                })(
                  <Input
                    className="email-input"
                    placeholder={formatMessage(
                      text.formPlaceholderCompanyPICEmail,
                    )}
                    size="large"
                    disabled={disableEmail}
                  />,
                )}
              </Form.Item>
              <div className="field photo-wrapper">
                <Form.Item
                  label={formatMessage(text.formLabelCompanyPICPhoto)}
                  colon={false}
                >
                  {getFieldDecorator('picPicture', {
                    initialValue: defaultPicPicture,
                    validateFirst: true,
                    rules: [
                      {
                        required: true,
                        message: formatMessage(
                          text.formRequiredCompanyPICPhoto,
                        ),
                      },
                      {
                        validator: this.uploadValidator.bind(this),
                      },
                    ],
                  })(
                    <Upload
                      name="logo"
                      accept=".jpeg,.jpg"
                      className="upload-wrapper"
                      {...picPhotoProps}
                    >
                      <Button>Pilih Gambar</Button>
                    </Upload>,
                  )}
                </Form.Item>
                <div>Maksimal ukuran file 1MB, format dalam .JPEG</div>
                <div className="error">
                  {this.state.isPicPhotoExceed
                    ? 'Foto yang diunggah melebihi 1MB, Tolong unggah foto lain'
                    : null}
                  {this.state.isPicPhotoIncorrectFormat
                    ? 'Format Foto yang diunggah harus dalam .JPEG atau .PNG'
                    : null}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderFormStep1 = () => (
    <div>
      {this.renderCompany()}
      {this.renderCompanyPIC()}
    </div>
  );

  renderFormStep2 = () => {
    const {
      intl: { formatMessage },
      employeeRoles,
    } = this.props;

    const { getFieldDecorator } = this.props.form;

    const isAvailableModulesLoading =
      !this.props.availableModulesLoading &&
      this.props.availableModules.length > 0;

    const defaultRoles = employeeRoles.filter(x => x.checked);

    return (
      <div className="page-section-box">
        <Row className="page-title-container">
          <Col span={24}>Employee Roles</Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="page-column-container">
              {isAvailableModulesLoading ? (
                <Form.Item
                  label={formatMessage(text.formLabelAllowedModules)}
                  colon={false}
                >
                  {getFieldDecorator('availableModules', {})(
                    <CompanyModules
                      availableModules={this.props.availableModules}
                      onSelectModule={this.props.onSelectModule}
                      colSpan={6}
                    />,
                  )}
                </Form.Item>
              ) : (
                <Spin />
              )}

              <Form.Item
                label={formatMessage(text.formLabelAvailableEmployeeRoles)}
                required
                colon={false}
                className="available-employee-roles"
              >
                {getFieldDecorator('availableEmployeeRoles', {
                  initialValue: defaultRoles,
                  rules: [
                    {
                      required: true,
                      message: formatMessage(text.formRequiredEmployeeRoles),
                    },
                  ],
                })(
                  <CompanyModules
                    availableModules={this.props.employeeRoles}
                    onSelectModule={this.onSelectEmployeeRoles}
                    colSpan={6}
                    placeholder={formatMessage(text.companyFormWarnSelectRole)}
                  />,
                )}
              </Form.Item>

              <EmployeeRolesView
                employeeRoles={this.props.employeeRoles}
                placeholder={formatMessage(text.companyFormWarnSelectRole)}
              />

              {isAvailableModulesLoading ? (
                <Form.Item
                  label={formatMessage(text.formLabelModulesPermission)}
                  colon={false}
                >
                  {getFieldDecorator('modulesPermission', {})(
                    <CompanyModulesView
                      availableModules={this.props.availableModules}
                      onSelectPermission={this.props.onSelectPermission}
                      placeholder={formatMessage(
                        text.companyFormWarnSelectRole,
                      )}
                    />,
                  )}
                </Form.Item>
              ) : (
                <Spin />
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  renderFormStep3 = () => {
    const {
      getSubmitModalSteps,
      submitAddCompanyState,
      submitAddUserState,
      submitAddEmployeeState,
      companyId,
      intl: { formatMessage },
    } = this.props;
    const submitModalSteps = getSubmitModalSteps();
    let title = '';
    let retryTitle = '';
    let remarksErrorTitle = '';
    let remarksErrorDescription = '';
    let remarksSuccessTitle = '';
    let remarksSuccessDescription = '';
    if (companyId) {
      title = formatMessage(text.companyFormUpdateSubmittingTitle);
      retryTitle = formatMessage(text.companyFormUpdateRetryTitle);
      remarksErrorTitle = formatMessage(
        text.companyFormUpdateRemarksErrorTitle,
      );
      remarksErrorDescription = formatMessage(
        text.companyFormUpdateRemarksErrorDescription,
      );
      remarksSuccessTitle = formatMessage(
        text.companyFormUpdateRemarksSuccessTitle,
      );
      remarksSuccessDescription = formatMessage(
        text.companyFormUpdateRemarksSuccessDescription,
      );
    } else {
      title = formatMessage(text.companyFormCreateSubmittingTitle);
      retryTitle = formatMessage(text.companyFormCreateRetryTitle);
      remarksErrorTitle = formatMessage(
        text.companyFormCreateRemarksErrorTitle,
      );
      remarksErrorDescription = formatMessage(
        text.companyFormCreateRemarksErrorDescription,
      );
      remarksSuccessTitle = formatMessage(
        text.companyFormCreateRemarksSuccessTitle,
      );
      remarksSuccessDescription = formatMessage(
        text.companyFormCreateRemarksSuccessDescription,
      );
    }

    return (
      <div className="page-section-box">
        <Row className="page-title-container">
          <Col span={24}>{title}</Col>
        </Row>
        <SubmitModal
          steps={submitModalSteps}
          formatMessage={formatMessage}
          submitAddCompanyState={submitAddCompanyState}
          submitAddUserState={submitAddUserState}
          submitAddEmployeeState={submitAddEmployeeState}
          retryTitle={retryTitle}
          remarksErrorTitle={remarksErrorTitle}
          remarksErrorDescription={remarksErrorDescription}
          remarksSuccessTitle={remarksSuccessTitle}
          remarksSuccessDescription={remarksSuccessDescription}
          remarksSuccessSubDescription={formatMessage(
            text.companyFormCreateRemarksSuccessSubDescription,
          )}
          remarksCreateAnother={formatMessage(
            text.companyFormCreateRemarksCreateAnother,
          )}
          resetSubmitModal={this.resetSubmitModal}
          companyId={companyId}
        />
      </div>
    );
  };

  resetSubmitModal = () => {
    const { resetSubmitModal, availableModules, employeeRoles } = this.props;
    const newState = {
      ...this.state,
      formValue: {},
      picPhotoFileList: [],
    };
    this.setState(newState);

    const newAvailableModules = availableModules.map(x => {
      const moduleName = _.get(x, 'name', '');
      const checked = moduleName.toLowerCase() === audiences.ORGANIZATION;
      return {
        ...x,
        view_all: false,
        checked,
      };
    });

    const newEmployeeRoles = employeeRoles.map(x => {
      const moduleIdentifier = _.get(x, 'module.identifier', '');
      const hideRole =
        moduleIdentifier.toLowerCase() !== audiences.ORGANIZATION;
      return {
        ...x,
        hidden: hideRole,
        checked: false,
      };
    });

    resetSubmitModal(newAvailableModules, newEmployeeRoles);
  };

  onClickCancel = () => {
    const { history } = this.props;
    history.goBack();
  };

  onClickBack = () => {
    const { updateCreateNewCompanyStep } = this.props;
    updateCreateNewCompanyStep(1);
  };

  onClickBackToCompanyList = () => {
    const { history } = this.props;
    history.replace('/dashboard/organization/company-list/view-company');
  };

  onClickBackToCompanyDetails = () => {
    const { history, companyId } = this.props;
    history.replace(`/dashboard/organization/company-detail/${companyId}`);
  };

  onClickNext = () => {
    const {
      form: { validateFields },
    } = this.props;

    const fieldsToValidate = [
      'companyName',
      'companyID',
      'npwpNumber',
      'legalEntity',
      'companyOwner',
      'companyEmail',
      'companyAddress',
      'picName',
      'picEmail',
      'picPhone',
      'picNationalID',
      'picPicture',
    ];

    validateFields(fieldsToValidate, this.onValidateCompanyData);
  };

  onValidateCompanyData = (err, formValues) => {
    const { updateCreateNewCompanyStep } = this.props;
    if (!err) {
      const newState = {
        ...this.state,
        formValue: formValues,
      };

      this.setState(newState);

      updateCreateNewCompanyStep(2);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    const fieldsToValidate = ['availableModules', 'availableEmployeeRoles'];

    validateFields(fieldsToValidate, this.onValidateRolesData);
  };

  onValidateRolesData = (err, formValues) => {
    const { onSubmit } = this.props;
    if (!err) {
      let picPicture = '';
      const { formValue } = this.state;

      if (
        formValue.picPicture &&
        formValue.picPicture.fileList &&
        formValue.picPicture.fileList.length > 0
      ) {
        picPicture =
          formValue.picPicture.fileList[
            formValue.picPicture.fileList.length - 1
          ].originFileObj;
      }

      const formVendorSubmit = {
        companyName: formValue.companyName,
        companyId: formValue.companyId,
        companyAddress: formValue.companyAddress,
        companyOwner: formValue.companyOwner,
        companyEmail: formValue.companyEmail,
        npwpNumber: formValue.npwpNumber,
        legalEntity: formValue.legalEntity,
        picName: formValue.picName,
        picEmail: formValue.picEmail,
        picPhone: formValue.picPhone,
        picNationalID: formValue.picNationalID,
        employeeRoles: formValues.availableEmployeeRoles,
        picPicture,
      };

      onSubmit(formVendorSubmit);
    }
  };

  renderSubmit = () => {
    const {
      intl: { formatMessage },
      companyId,
      createNewCompanyStep,
      submitAddCompanyState,
      submitAddUserState,
      submitAddEmployeeState,
      onCancelModal,
    } = this.props;

    let btnText = '';
    if (companyId) {
      btnText = formatMessage(text.btnEdit);
    } else {
      btnText = formatMessage(text.btnRegister);
    }

    const displayCancelButton =
      createNewCompanyStep === 3 &&
      submitAddEmployeeState !== submitModalState.SUCCESS;

    const dipslayBackToListButton =
      createNewCompanyStep === 3 &&
      submitAddEmployeeState === submitModalState.SUCCESS &&
      !companyId;

    const dipslayBackToDetailsButton =
      createNewCompanyStep === 3 &&
      submitAddEmployeeState === submitModalState.SUCCESS &&
      companyId;

    const enabledCancel =
      submitAddCompanyState === submitModalState.FAILED ||
      submitAddUserState === submitModalState.FAILED ||
      submitAddEmployeeState === submitModalState.FAILED;

    return (
      <div className="submit-container">
        {createNewCompanyStep === 1 && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            onClick={this.onClickCancel}
          >
            Cancel
          </Button>
        )}
        {createNewCompanyStep === 2 && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            onClick={this.onClickBack}
          >
            Back
          </Button>
        )}
        {createNewCompanyStep === 1 && (
          <Button
            type="primary"
            block
            className="register-vendor-submit-btn"
            onClick={this.onClickNext}
          >
            Next
          </Button>
        )}
        {createNewCompanyStep === 2 && (
          <Button
            type="primary"
            block
            className="register-vendor-submit-btn"
            htmlType="submit"
          >
            {btnText}
          </Button>
        )}
        {displayCancelButton && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            disabled={!enabledCancel}
            onClick={onCancelModal}
          >
            Cancel
          </Button>
        )}
        {dipslayBackToListButton && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            onClick={this.onClickBackToCompanyList}
          >
            Back to Company List
          </Button>
        )}
        {dipslayBackToDetailsButton && (
          <Button
            block
            type="default"
            className="register-vendor-normal-btn"
            onClick={this.onClickBackToCompanyDetails}
          >
            Back to Details
          </Button>
        )}
      </div>
    );
  };

  _handleSubmitFinishOk = () => {
    this.props.updateSubmitModalFinishOpen(false, [], []);
    const getIdCompany = _.get(this.props, 'match.params.id', '');
    if (getIdCompany) {
      this.props.history.push(
        organizationRoute.COMPANY_DETAIL.replace(':id', getIdCompany),
      );
    } else {
      this.props.history.push(
        organizationRoute.COMPANY_LIST.replace(':tab', 'view-all'),
      );
    }
  };

  _handleSubmitErrorOk = () => {
    this.props.updateSubmitModalErrorOpen(false);
  };

  _renderSubmitFinishModal = () => {
    const {
      intl: { formatMessage },
      companyId,
    } = this.props;

    const description = companyId
      ? formatMessage(text.updateCompanySuccessDescription)
      : formatMessage(text.createNewCompanySuccessDescription);

    return (
      <CallbackModal
        onClose={this._handleSubmitFinishOk}
        modalVisible={this.props.submitModalFinishOpen}
        type="success"
        description={description}
      />
    );
  };

  _renderSubmitErrorModal = () => {
    const {
      intl: { formatMessage },
      companyId,
    } = this.props;

    const description = companyId
      ? formatMessage(text.updateCompanyErrorDescription)
      : formatMessage(text.createNewCompanyErrorDescription);

    return (
      <CallbackModal
        onClose={this._handleSubmitErrorOk}
        modalVisible={this.props.submitModalErrorOpen}
        type="failed"
        description={description}
      />
    );
  };

  render() {
    const { createNewCompanyStep } = this.props;
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          {createNewCompanyStep === 1 && this.renderFormStep1()}
          {createNewCompanyStep === 2 && this.renderFormStep2()}
          {createNewCompanyStep === 3 && this.renderFormStep3()}
          {this.renderSubmit()}
          {this._renderSubmitFinishModal()}
          {this._renderSubmitErrorModal()}
        </Form>
      </div>
    );
  }
}

FormCompanyRegister.propTypes = {
  form: PropTypes.object,
  formValue: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  btnText: PropTypes.string,
  intl: PropTypes.object.isRequired,
  availableModules: PropTypes.array.isRequired,
  onSelectModule: PropTypes.func.isRequired,
  onSelectPermission: PropTypes.func,
  employeeRoles: PropTypes.array.isRequired,
  onSelectRole: PropTypes.func,
  getAllTokenLoading: PropTypes.bool,
  availableModulesLoading: PropTypes.bool,
  updateSubmitModalFinishOpen: PropTypes.func.isRequired,
  submitModalFinishOpen: PropTypes.bool.isRequired,
  resetAvailableModules: PropTypes.func.isRequired,
  loadingEmployeeRoles: PropTypes.bool,
  history: PropTypes.object,
  companyId: PropTypes.string,
  companyDetails: PropTypes.object,
  employeeDetails: PropTypes.object,
  getLoading: PropTypes.bool,
  submitModalErrorOpen: PropTypes.bool,
  updateSubmitModalErrorOpen: PropTypes.func,
  match: PropTypes.object,
  createNewCompanyStep: PropTypes.number,
  updateCreateNewCompanyStep: PropTypes.func,
  createNewCompanyParams: PropTypes.object,
  getModulesParam: PropTypes.func,
  submitAddCompanyState: PropTypes.string,
  submitAddUserState: PropTypes.string,
  submitAddEmployeeState: PropTypes.string,
  getSubmitModalSteps: PropTypes.func,
  onCancelModal: PropTypes.func,
  resetSubmitModal: PropTypes.func,
  updateEmployeeRolesAll: PropTypes.func,
};

export default FormCompanyRegister;
